import { CellsGeojson, Threat } from '@/api/rest/resources/conservation';

import { useConservationFile } from './useConservation';
import { useConservationProjectName } from './useConservationProjectName';

export const useThreatGeojson = (threat: Threat, id?: string) => {
  const projectName = useConservationProjectName(id);

  if (!projectName) {
    throw new Error('Conservation project name not found');
  }

  return useConservationFile<CellsGeojson>({
    projectName,
    fileName: `threat_${threat}.json`,
  });
};
